module.exports = __webpack_public_path__ + "static/Multi-Column-Filtering-534cf48787787aa7f6420fd9647db807.png";